import { render, staticRenderFns } from "./InformationPopup.vue?vue&type=template&id=2dea5c36&"
import script from "./InformationPopup.vue?vue&type=script&lang=ts&"
export * from "./InformationPopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports